import axios from 'axios'

const BASE_URL = 'https://ai-lab.hebei.com.cn/api/jyvoteplus/api1';

const VOTE_URL = 'https://ai-lab.hebei.com.cn/api/jyvoteplus/api';
const UPLOAD_URL = 'https://appapi.hebei.com.cn/api/2026hbxczbzj/api';

const request = axios.create({
  timeout: 30000
})
const requestFile = axios.create({
  timeout: 120000
})
function stringifyData(data) {
  return JSON.stringify(data)
}

function postForm(url, params) {
  var data = new URLSearchParams()
  Object.keys(params).forEach(function(key) {
    data.append(key, typeof params[key] === 'string' ? params[key] : stringifyData(params[key]))
  })
  return request.post(url, data)
}

export function getVoteList(params) {
  return postForm(BASE_URL + '/list.php', { vid: stringifyData(params) })
}

export function searchVoteList(params) {
  return postForm(BASE_URL + '/search.php', { search: stringifyData(params) })
}

export function getVoteDetail(params) {
  return postForm(BASE_URL + '/detail.php', { pid: stringifyData(params) })
}

export function submitVote(params) {
  return postForm(VOTE_URL + '/vote_21.php', { vote: stringifyData(params) })
}

export function uploadImage(file, onProgress) {
  var formData = new FormData()
  formData.append('file', file)
  return requestFile.post(UPLOAD_URL + '/imgupload.php', formData, {
    onUploadProgress: onProgress
  })
}

export function uploadFile(file, type, onProgress,videoUrl) {
	let url = ''
	if (type=='视频作品'){
		url = videoUrl;
		return requestFile.put(videoUrl, file, {
			onUploadProgress: onProgress
		})
	}else{
		url = 'imgupload.php';
	}
	var formData = new FormData()
	formData.append('file', file)
	return requestFile.post(UPLOAD_URL + '/' + url, formData, {
		onUploadProgress: onProgress
	})
}
export function getCityList(params) {
  return request.get(UPLOAD_URL + '/citylist.php')
}
export function getSubcategoryList(params) {
  return request.get(UPLOAD_URL + '/categorylist.php')
}

export function submitEntry(params) {
  return request.get(UPLOAD_URL + '/receive.php?message=' + stringifyData(params))
}

export function getBigFileUploadUrl() {
  return request.get(UPLOAD_URL + '/bigfileupload.php')
}

export function visitLog() {
  return request.get(UPLOAD_URL + '/fwl.php')
}

export function getFileType(file) {
  var filename = file
  var index1 = filename.lastIndexOf('.')
  var index2 = filename.length
  return filename.substring(index1 + 1, index2)
}
